import { QGenericIndex } from "./QGenericIndex";
import { QXMLParam } from "./QXMLParam";

export class QXMLLoadObj {
  constructor() {
    this.fParent = null;
    this.fChildren = null;
    this.fValue = "";
    this.fElementName = null;

    this.fParams = null;

    this.fNameIndex = null;
  }

  InitObj(elementName, parent) {
    this.fElementName = elementName;
    this.fParent = parent;
  }

  BuildIndex() {
    this.fNameIndex = new QGenericIndex();
    this.fNameIndex.InitIndex();

    var n = this.GetNumChildren();
    for (var i = 0; i < n; i++) {
      var c = this.GetIndexChild(i);
      this.fNameIndex.AddToIndex(c, c.GetElementName());
    }
  }

  GetElementName() {
    return this.fElementName;
  }

  AddChild(theChild) {
    if (this.fChildren == null) this.fChildren = [];

    this.fChildren.push(theChild);
  }

  GetParent() {
    return this.fParent;
  }

  GetNumChildren() {
    if (this.fChildren == null) return 0;

    return this.fChildren.length;
  }

  GetChildOfTypeList(childName) {
    var childList = [];

    var n = this.GetNumChildren();
    for (var i = 0; i < n; i++) {
      var aChild = this.GetIndexChild(i);
      var cName = aChild.GetElementName();
      if (childName == cName) childList.push(aChild);
    }

    return childList;
  }

  GetIndexChild(index) {
    return this.fChildren[index];
  }

  ClearChild(index) {
    this.fChildren[index] = null;
  }

  //var gCallCounter = 0;
  PGetChildByName(childName) {
    // gCallCounter++;
    var n = this.GetNumChildren();
    for (var i = 0; i < n; i++) {
      var aChild = this.GetIndexChild(i);
      var cName = aChild.GetElementName();
      if (childName == cName) return aChild;
    }

    return null;
  }

  GetChildByName(childName) {
    if (this.fNameIndex) return this.fNameIndex.FindObject(childName);
    else return this.PGetChildByName(childName);
  }

  GetValueForChild(childName, forceInt) {
    var retVal = null;
    var theChild = this.GetChildByName(childName);
    if (theChild) {
      retVal = theChild.GetValue();
      if (forceInt) {
        if (retVal != "null") retVal = parseInt(retVal);
        else retVal = null;
      }
    }
    return retVal;
  }

  GetValueListForChild(childName, forceInt) {
    var theList = null;
    var theChild = this.GetChildByName(childName);
    if (theChild) {
      // Need to handle encoding so commas in text won't cause an issue
      var aString = theChild.GetValue();
      theList = aString.split(",");
    }

    if (forceInt && theList != null) {
      var n = theList.length;
      if (n == 0) return null;
      for (var i = 0; i < n; i++) {
        var v = theList[i];
        if (v != "null") theList[i] = parseInt(v);
        else theList[i] = null;
        //theList[i] = parseInt(theList[i]); //FEB28
      }
    }

    return theList;
  }

  AddValue(theValue) {
    if (this.fValue.length > 0) this.fValue += theValue;
    else this.fValue = theValue;
  }

  GetValue() {
    return this.fValue;
  }

  //==============================================================================
  // Parameter manangement
  ProcessParams(rawParams) {
    var adjParams = new Array();
    var param = rawParams.shift(); // First param is the tag
    if (param == null) return adjParams;

    param = rawParams.shift();
    while (param != null) {
      var l = param.length;
      if (l > 0) {
        //lastChar = param[l-1];
        if (param.indexOf("=") == -1) {
          var prior = adjParams.pop();
          param = prior + " " + param;
        }

        adjParams.push(param);
      }
      param = rawParams.shift();
    }

    return adjParams;
  }

  AddParams(rawParams) {
    // rawParam[0] is the tag
    var adjParams = this.ProcessParams(rawParams);
    var n = adjParams.length;
    for (var i = 0; i < n; i++) {
      if (this.fParams == null) this.fParams = new Array();
      var p = adjParams[i];
      var paramObj = new QXMLParam();

      var pair = p.split("=");
      var key = pair[0];
      var value = pair[1];

      paramObj.InitParam(key, value);
      this.fParams.push(paramObj);
    }
  }

  GetIndexParam(theIndex) {
    if (this.fParams == null) return null;

    return this.fParams[theIndex];
  }

  GetParamCount() {
    if (this.fParams == null) return 0;

    return this.fParams.length;
  }

  GetParamByName(paramName) {
    var n = this.GetParamCount();
    for (var i = 0; i < n; i++) {
      var p = this.GetIndexParam(i);
      var pName = p.GetParamName();
      if (pName == paramName) return p;
    }

    return null;
  }

  LogToConsole() {
    var openString = "<" + this.GetElementName() + ">";
    openString = openString + this.GetValue();
    console.log(openString);

    var n = this.GetNumChildren();
    for (var i = 0; i < n; i++) {
      var c = this.GetIndexChild(i);
      c.LogToConsole();
    }

    var closeString = "</" + this.GetElementName() + ">";
    console.log(closeString);
  }
}
